import {
  Card,
  Flex,
  EmptyBox,
  CardProps,
  List,
  ListHeader
} from '@blockanalitica/ui';
import { ReactNode } from 'react';

interface CardListProps extends Omit<CardProps, 'title'> {
  title?: string | ReactNode;
  action?: ReactNode;
  children: ReactNode | ReactNode[];
}

export default function CardList({
  children,
  title,
  action,
  ...rest
}: CardListProps) {
  return (
    <Card {...rest}>
      <List>
        <ListHeader
          title={title}
          actions={[
            <Flex key="listAction" fontSize="0">
              {action}
            </Flex>
          ]}
        />
        {children ? children : <EmptyBox />}
      </List>
    </Card>
  );
}
